import { useContext, useEffect, useMemo } from 'react';

import styles from "../styles/components/info-panel.module.scss";

import { FormGroup, Stack, Switch, Typography } from '@mui/material';
import { ExploreContext } from '../context/explore';
import { LocationsContext } from '../context/locations';
import { MapDataContext } from '../context/map-data';
import { getItemByKeyValue } from '../helpers/core';
import { AreaSummaryTable } from './area-summary-table';
import Loader from './loader';
import { PanToLocationButton } from './pan-to-location-button';
import { PopUpContent } from './popup-content';
import { StyledMarkdown } from './typeface';

interface Props {
  onToggleExplore: (panels: string[]) => void
}
export const InfoPanel = ({
  onToggleExplore
}: Props) => {

  const {
    exploreLocationParams,
  } = useContext(ExploreContext);

  useEffect(() => {
    if (exploreLocationParams === null) {
      onToggleExplore([])
    } else {
      onToggleExplore(["model","regions","layers","maps","data","custom"])
    }
  }, [exploreLocationParams])

  return (
    <PopUpContent />
  )
}

interface AreaInfoPanelProps {
  currentLocationUid: number | string | null
}

export const AreaInfoPanel = ({
  currentLocationUid
}: AreaInfoPanelProps) => {
  const {
    setShowMax,
    setShowMin,
  } = useContext(MapDataContext);
  
  const {
    currentShapeUid,
    visibleLayerLocationShapes,
    locations,
    loading,
  } = useContext(LocationsContext);

  const currentLocationObject = useMemo(() => {
    const found = getItemByKeyValue(locations, 'uid', currentLocationUid, false, false)
    return found
  }, [currentLocationUid, locations])

  const currentLocationSummary = useMemo(() => {
    if (visibleLayerLocationShapes && currentShapeUid !== null) {
      const found = getItemByKeyValue(visibleLayerLocationShapes, 'shape_uid', currentShapeUid)
      if (found !== -1) {
        return found
      }
    }
    return null
  }, [visibleLayerLocationShapes, currentShapeUid])

  if (loading.indexOf('visible-shapes-info') !== -1) {
    return <Loader small center />
  }
  return (
    <>
      {(visibleLayerLocationShapes && visibleLayerLocationShapes?.length >= 30) &&
          <div className={styles.content}>
            <StyledMarkdown>
              {currentLocationObject.notes}
            </StyledMarkdown>
          </div>
        }
        {(visibleLayerLocationShapes && visibleLayerLocationShapes?.length > 0 && visibleLayerLocationShapes?.length < 30000) && 
        <>
          <div className={styles.buttonRow}>
            <FormGroup>
              <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                <Typography>Max values</Typography>
                  <Switch defaultChecked onChange={(e) => {
                      const showMin = e.currentTarget.checked
                      if (showMin) {
                        setShowMax(false)
                        setShowMin(true)
                      } else {
                        setShowMax(true)
                        setShowMin(false)
                      }
                    }} />
                  <Typography>Min values</Typography>
                </Stack>
              </FormGroup>
              <PanToLocationButton
                disabled={currentLocationSummary === null} 
                centroid={currentLocationSummary ? currentLocationSummary?.centroid : null} 
              />
            </div>
            <AreaSummaryTable />
          </>
        }

    </>
  )
}
